import { render, staticRenderFns } from "./productLabelManagement.vue?vue&type=template&id=4da0a741&scoped=true&"
import script from "./productLabelManagement.vue?vue&type=script&lang=js&"
export * from "./productLabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./productLabelManagement.vue?vue&type=style&index=0&id=4da0a741&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0a741",
  null
  
)

export default component.exports